<script>
  import DropDown from '../../components/DropDown.svelte';
  import { searchKeyByValue, configItem } from 'components/Helper.js';
  import { Modal } from 'bootstrap';
  import { custom_event } from 'svelte/internal';
  let frequency = [...configItem.recurringTypes, { id: 6, name: 'Custom' }];

  let recurringType = configItem.customRecurringTypes;

  let repeat = [
    { id: 1, text: '1' },
    { id: 2, text: '2' },
    { id: 3, text: '3' },
    { id: 4, text: '4' },
    { id: 5, text: '5' },
  ];
  export let selectedTasks;
  let frequencyError;
  let recurringRow;
  export let param = {
    isBulk: true,
    recurringEvery: 1,
    frequencyType: 1,
    recurringType: 1,
    recurringCustom: 0,
  };
  export let onBulkAction;
  let comeFrom = 'changeRecurring';
  export const setRecurringRow = (row) => {
    if (row == undefined) {
      param = {
        isBulk: true,
        recurringEvery: 1,
        frequencyType: 1,
        recurringType: 1,
        recurringCustom: 0,
      };
      frequencyTitle = 'Daily';
      recurringTypeTitle = 'Daily';
      comeFrom = 'changeRecurring';
    } else {
      param = {
        isBulk: false,
        recurringCustom: row.recurringCustom,
        recurringType: row.recurringType,
        frequencyType: row.recurringCustom == 1 ? 6 : row.recurringType,
        recurringEvery: row.recurringEvery,
      };
      if (row.recurringCustom == 1) {
        frequencyTitle = frequency[5].name;
        let key = searchKeyByValue(recurringType, 'id', row.recurringType);
        recurringTypeTitle = recurringType[key].name;
      } else {
        recurringTypeTitle = 'Select';
        let key = searchKeyByValue(frequency, 'id', row.recurringType);
        frequencyTitle = frequency[key].name;
      }
      comeFrom = 'updateRecurring';
    }
  };
  let frequencyTitle = 'Select';
  let recurringTypeTitle = 'Select';
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="changeFrequency"
  tabindex="-1"
  aria-labelledby="changeFrequencyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Change Task Frequency
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          {#if param.isBulk}
            <label
              for=""
              class="mb-3 color-lead">{selectedTasks.length} Tasks selected</label
            >
          {/if}
          <div class="row justify-content-between">
            <div class="col-md-4 mb-3">
              <DropDown
                deleteSelected={false}
                checkbox={false}
                titleChanged={true}
                active={true}
                title={frequencyTitle}
                option={frequency}
                Style="select-block d-inline-block font-size-13 select-box-dropdown"
                on:onSelect={(item) => {
                  param.frequencyType = item.detail.id;
                  param.recurringCustom = param.frequencyType == 6 ? 1 : 0;
                  if (param.recurringCustom == 0) {
                    param.recurringType = item.detail.id;
                  } else {
                    param.recurringType = 1;
                    param.recurringEvery = 1;
                    recurringTypeTitle = recurringType[0].name;
                  }
                }}
              />
            </div>
          </div>
          {#if param.recurringCustom == 1}
            <label>Repeat Every</label>
            <div class="d-flex flex-row mt-1">
              <div class="me-1 time-recurring">
                <input
                  bind:value={param.recurringEvery}
                  type="number"
                  min="1"
                  max="50"
                  placeholder="Every"
                  class="form-control freuency-block"
                />
              </div>
              <div class="">
                <DropDown
                  deleteSelected={false}
                  checkbox={false}
                  titleChanged={true}
                  active={true}
                  title={recurringTypeTitle}
                  option={recurringType}
                  Style="select-block d-inline-block font-size-13 select-box-dropdown"
                  on:onSelect={(item) => {
                    param.recurringType = item.detail.id;
                  }}
                />
              </div>
            </div>
          {/if}
          {#if frequencyError}
            <label
              class="formError"
              for="id"
            >
              {frequencyError}
            </label>
          {/if}
        </div>
      </div>
      <div class="modal-footer border-0">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          on:click={() => {
            frequencyError = null;
            if (
              param.recurringCustom == 1 &&
              (param.recurringEvery > 50 || param.recurringEvery < 0)
            ) {
              frequencyError = 'Please enter between 1 to 50';
              return false;
            }
            var modal = Modal.getInstance(document.getElementById('changeFrequency'));
            modal.hide();
            onBulkAction({
              ...param,
              comeFrom,
            });
          }}>Save</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .time-recurring {
    width: 80px;
  }

  .freuency-block {
    height: 34px;
  }
</style>
